import * as reduxService from './../../../../services/redux';

import * as models from './models';
import * as actions from './actions';

export default reduxService.createReducer({
  state: models.default,
  action: actions.UPDATE
});